import JsCookie from "js-cookie";

import { config } from "@/config";

export const Cookies = JsCookie.withAttributes({
  domain: `.${config.app.site}.com`,
  sameSite: "Strict"
});
